import {
  StyleRulesCallback,
  WithStyles,
  withStyles as withStylesCb
} from "@material-ui/core/styles";

export const styles: StyleRulesCallback = ({ spacing: { unit } }) => ({
  container: {
    pointerEvents: "none",
    opacity: 0.5
  },
  progressBar: {
    marginBottom: unit * 2
  }
});

export type Styles = WithStyles<typeof styles>;
export const withStyles = withStylesCb(styles);
